export const GET_USER_LINKS_REQUEST = 'GET_USER_LINKS_REQUEST'
export const GET_USER_LINKS_SUCCESS = 'GET_USER_LINKS_SUCCESS'
export const GET_USER_LINKS_FAILURE = 'GET_USER_LINKS_FAILURE'
